import React from 'react'
import H from './H'
import { s, sTextGradientBlack } from '../style'

const Headline = ({
  h,
  title,
  desc,
  gradient,
  large,
  medium,
  children,
  dimmed,
  center,
  space,
  uppercase,
  margin,
  maxWidth,
  blog,
  search
}) => {
  return (
    <>
      <H
        h={h}
        css={[
          sTitle,
          gradient && sTextGradientBlack,
          large && { fontSize: '3rem', [s.sm_down]: { fontSize: '2rem' } },
          medium && { fontSize: '2rem', [s.sm_down]: { fontSize: '2rem' } },
          center && { textAlign: 'center', width: '100%' },
          dimmed && { opacity: 0.3 },
          space && { letterSpacing: '0.5em' },
          uppercase && { textTransform: 'uppercase' },
          search && {[s.xs]: {fontSize: '1.15rem'}}
        ]}>
        {title || children}
      </H>
      {desc && (
        <p
          css={[
            sDesc,
            maxWidth && {
              [s.md]: {
                maxWidth: '100%',
              },
            },
            blog && {
              marginLeft: '1rem',
            },
            search && sDescSearch
          ]}
          dangerouslySetInnerHTML={{
            __html: desc,
          }} />
      )}
    </>
  )
}

const sTitle = {
  fontSize: '1.5rem',
  margin: 0,
  padding: 0,
  zIndex: 2,
  width: 'max-content',
  maxWidth: '100%',
  textAlign: 'left',
  letterSpacing: '-0.05em',
  fontWeight: 700,
  [s.sm_down]: {
    width: '100%',
    marginBottom: 0,
  },
}

const sDesc = {
  marginTop: '2rem',
  opacity: 0.6,
  lineHeight: '2em',
  [s.sm_down]: {
    fontSize: '0.75rem',
  },
  [s.md]: {
    maxWidth: '66%',
  },
  a: {
    color: '#3a9300',
  }
}

const sDescSearch = {
  marginTop: '0',
  textAlign: 'center',
  lineHeight: 1.15,
  [s.xs]: {
    marginTop: '0.5rem'
  }
}

export default Headline
